<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <Aguarde :show="showAguarde"></Aguarde>
      <div class="col-md-12">
        <div class="card">
          <nota-fiscal v-if="true" :ranfs="true" :substituicao="false"></nota-fiscal>
          <Loader v-if="false" :loading="httpSend">
            <div class="card-body">
              <form-wizard ref="tabNota" next-button-text="Próximo" back-button-text="Anterior" color="#556ee6">
                <tab-content :before-change="validaTabServico" :lazy="true" title="Nota e Serviços"
                             icon="bx bx-phone-call">
                  <div class="row">
                    <div class="col-12">
                      <b-form>
                        <div class="row">
                          <h5 class="mb-3">Informações sobre a Nota Fiscal</h5>
                        </div>
                        <div class="row">
                          <div class="col-md-3">
                            <b-form-group label="Número da Nota Fiscal" label-for="ran_numero">
                              <input class="form-control" v-model="servico.ran_numero"
                                     maxlength="15"
                                     :class="{'is-invalid': submittedServicos && $v.servico.ran_numero.$error }"
                                     id="ran_numero" type="text">
                              <div v-if="submittedServicos && $v.servico.ran_numero.$error" class="invalid-feedback">
                                Informe o número da Nota
                              </div>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="Emissão da Nota Fiscal" label-for="ran_nota_emissao">
                              <input class="form-control" v-model="servico.ran_nota_emissao"
                                     :class="{'is-invalid': submittedServicos && $v.servico.ran_nota_emissao.$error }"
                                     id="ran_nota_emissao" type="date">
                              <div v-if=" submittedServicos && $v.servico.ran_nota_emissao.$error"
                                   class="invalid-feedback">
                                Informe a emissão da Nota
                              </div>
                            </b-form-group>
                          </div>
                          <div class="col-md-6">
                            <b-form-group label="Chave de Acesso da NFS-e Nacional" label-for="ran_not_nsu">
                              <input class="form-control" v-model="servico.ran_not_nsu"
                                     maxlength="15"
                                     :class="{'is-invalid': submittedServicos && $v.servico.ran_not_nsu.$error }"
                                     id="ran_numero" type="text">
                              <div v-if="submittedServicos && $v.servico.ran_not_nsu.$error" class="invalid-feedback">
                                Informe o número a chave de acesso da NFS-e Nacional
                              </div>
                            </b-form-group>
                          </div>
                        </div>
                      </b-form>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <b-form>
                        <div class="row">
                          <h5 class="mb-3">Mês e ano da prestação do serviço (Fato Gerador do Imposto)</h5>
                        </div>
                        <div class="row">
                          <div class="col-md-3">
                            <b-form-group label="Mês" label-for="mes_competencia">
                              <select id="mes_competencia" v-model="competencia.mes"
                                      class="custom-select"
                                      :class="{'is-invalid': $v.competencia.mes.$error }"
                                      type="text">
                                <option value="1">Janeiro</option>
                                <option value="2">Fevereiro</option>
                                <option value="3">Março</option>
                                <option value="4">Abril</option>
                                <option value="5">Maio</option>
                                <option value="6">Junho</option>
                                <option value="7">Julho</option>
                                <option value="8">Agosto</option>
                                <option value="9">Setembro</option>
                                <option value="10">Outubro</option>
                                <option value="11">Novembro</option>
                                <option value="12">Dezembro</option>
                              </select>
                              <div v-if=" $v.competencia.mes.$error" class="invalid-feedback">
                                Informe o mês
                              </div>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="Ano" label-for="ano_competencia">
                              <input class="form-control" v-model="competencia.ano"
                                     v-mask="'####'"
                                     :class="{'is-invalid': $v.competencia.ano.$error }"
                                     id="ano_competencia" type="text">
                              <div v-if=" $v.competencia.ano.$error" class="invalid-feedback">
                                Informe o ano
                              </div>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="Competência" label-for="competencia">
                              <input class="form-control" v-model="sep_competencia"
                                     v-bind:disabled="true"
                                     id="competencia" type="text">
                            </b-form-group>
                          </div>
                        </div>
                      </b-form>
                    </div>
                  </div>
                  <div class="row">
                    <h5 class="mb-3">Informação sobre o serviço</h5>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <b-form-group label="Município onde o serviço foi prestado" label-for="sep_municipio_prestacao">
                        <multiselect
                            id="sep_municipio_prestacao"
                            v-model="servico.sep_municipio_prestacao"
                            placeholder="Selecione município"
                            track-by="mun_codigo"
                            :custom-label="labelMunicipio"
                            :class="{'is-invalid': !servico.sep_municipio_prestacao.mun_codigo}"
                            :options="municipios"
                            :close-on-select="true"
                            :option-height="104"
                            :loading="isLoading"
                            :searchable="true"
                            :internal-search="false"
                            :allowEmpty="false"
                            :max-height="600"
                            :show-no-results="false"
                            @search-change="pesquisarMunicipio"
                            :show-labels="false">
                          <template slot="option" slot-scope="props">
                            <div class="option__desc">
                              <span class="option__title">{{ props.option.mun_nome }} - {{ props.option.mun_uf }}</span>
                            </div>
                          </template>
                          <span slot="noOptions">Digite para pesquisar</span>
                        </multiselect>
                        <h6 v-show="!servico.sep_municipio_prestacao.mun_codigo" class="invalid-feedback">
                          Informe o município</h6>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <b-form-group label="Atividade desenvolvida" label-for="ser_codigo">
                        <multiselect
                            id="ser_codigo"
                            v-model="servico.ser_codigo"
                            placeholder="Selecione a Atividade"
                            track-by="ser_codigo"
                            :custom-label="labelServico"
                            :class="{'is-invalid': submittedServicos && $v.servico.ser_codigo.$error}"
                            :options="servicos"
                            :close-on-select="true"
                            :option-height="104"
                            :loading="isLoading"
                            :searchable="true"
                            :internal-search="true"
                            :allowEmpty="false"
                            :max-height="600"
                            :show-no-results="false"
                            @search-change="pesquisarServicos"
                            :show-labels="false">
                          <template slot="option" slot-scope="props">
                            <div class="option__desc">
                              <span class="option__title">{{ props.option.ser_codigo }} - {{
                                  props.option.ser_descricao
                                }}</span>
                            </div>
                          </template>
                          <span slot="noOptions">Digite para pesquisar</span>
                        </multiselect>
                        <h6 v-show="submittedServicos && $v.servico.ser_codigo.$error" class="invalid-feedback">
                          Selecione a atividade desenvolvida</h6>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <b-form-group label="Cnae" label-for="cnae_codigo">
                        <multiselect
                            id="cnae_codigo"
                            v-model="servico.cnae_codigo"
                            placeholder="Selecione o Cnae"
                            track-by="cnae_codigo"
                            :custom-label="labelCnae"
                            :options="cnaes"
                            :close-on-select="true"
                            :option-height="104"
                            :loading="isLoading"
                            :searchable="true"
                            :internal-search="false"
                            :allowEmpty="false"
                            :max-height="600"
                            :show-no-results="false"
                            @search-change="pesquisarCnae"
                            :show-labels="false">
                          <template slot="option" slot-scope="props">
                            <div class="option__desc">
                              <span class="option__title">{{ props.option.cnae_codigo }} - {{
                                  props.option.cnae_nome
                                }}</span>
                            </div>
                          </template>
                          <span slot="noOptions">Digite para pesquisar</span>
                        </multiselect>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <h5 class="mb-3">Informação sobre tributação do ISS</h5>
                  </div>
                  <div class="row">
                    <div class="col-md-5">
                      <b-form-group label="Tributação do ISS" label-for="sep_exigibilidade_iss">
                        <select id="sep_exigibilidade_iss"
                                v-bind:disabled="verificaTributacao.disableTributacao"
                                v-model="servico.sep_exigibilidade_iss"
                                @change="selctTributacao(servico.sep_exigibilidade_iss)"
                                class="custom-select" type="text">
                          <option value="1">No Município</option>
                          <option value="2">Tributada fora do Município</option>
                        </select>
                      </b-form-group>
                    </div>
                    <div class="col-md-7">
                      <b-form-group label="Município onde é tributado o ISS" label-for="sep_municipio_incidencia">
                        <multiselect
                            v-if="servico.sep_exigibilidade_iss !== '1'"
                            id="sep_municipio_incidencia"
                            v-model="servico.sep_municipio_incidencia"
                            placeholder="Selecione município"
                            :class="{'is-invalid': !servico.sep_municipio_incidencia.mun_codigo}"
                            track-by="mun_codigo"
                            :custom-label="labelMunicipio"
                            :options="municipios"
                            :close-on-select="true"
                            :allowEmpty="false"
                            :option-height="104"
                            :loading="isLoading"
                            :searchable="true"
                            :internal-search="true"
                            :max-height="600"
                            :show-no-results="false"
                            @search-change="pesquisarMunicipio"
                            :show-labels="false">
                          <template slot="option" slot-scope="props">
                            <div class="option__desc">
                                    <span class="option__title">{{ props.option.mun_nome }} - {{
                                        props.option.mun_uf
                                      }}</span>
                            </div>
                          </template>
                          <span slot="noOptions">Digite para pesquisar</span>
                        </multiselect>
                        <h4 class="mt-3" v-else>{{ servico.sep_municipio_incidencia.mun_nome }} -
                          {{ servico.sep_municipio_incidencia.mun_uf }} </h4>
                        <h6 v-show="!servico.sep_municipio_incidencia.mun_codigo" class="invalid-feedback">
                          Informe o município</h6>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <b-form-group label="Descrição dos serviço" label-for="sep_discriminacao">
                        <textarea
                            v-model="servico.sep_discriminacao"
                            class="form-control"
                            :class="{'is-invalid': submittedServicos && $v.servico.sep_discriminacao.$error }"
                            :maxlength="2000"
                            rows="15"
                            placeholder="Descrição do serviço máximo de 2000 caracteres"
                        ></textarea>
                        <div class="text-center">
                          <p v-if="servico.sep_discriminacao" class="badge position-absolute"
                             :class="{ 'badge-success': servico.sep_discriminacao.length !== 2000,
                            'badge-danger': servico.sep_discriminacao.length === 2000 }">
                            {{ servico.sep_discriminacao.length }} / 2000
                          </p>
                        </div>
                        <h6 v-show="submittedServicos && $v.servico.sep_discriminacao.$error" class="invalid-feedback">
                          Informe a descrição do serviço realizado</h6>
                      </b-form-group>
                    </div>
                  </div>
                </tab-content>
                <tab-content :before-change="validaTabPrestador" title="Prestador" icon="bx bx-briefcase-alt">
                  <div class="row">
                    <div class="col-12">
                      <b-form>
                        <div class="row">
                          <h5 class="mb-3">Dados do Prestador</h5>
                        </div>
                        <div class="row">
                          <div class="col-md-4">
                            <b-form-group label="CPF/CNPJ" label-for="sep_cpf_cnpj_prestador">
                              <the-mask class="form-control"
                                        :class="{ 'is-invalid': $v.prestador.sep_cpf_cnpj_prestador.$error }"
                                        v-model="prestador.sep_cpf_cnpj_prestador"
                                        v-on:focusout.native="locTomador(prestador.sep_cpf_cnpj_prestador)"
                                        :mask="['###.###.###-##', '##.###.###/####-##']"/>
                              <div v-if=" $v.prestador.sep_cpf_cnpj_prestador.$error" class="invalid-feedback">
                                Informe o CPF/CNPJ
                              </div>
                            </b-form-group>
                          </div>
                          <div class="col-md-5">
                            <b-form-group label="Nome/Razão social" label-for="sep_razao_social_prestador">
                              <input class="form-control" v-model="prestador.sep_razao_social_prestador"
                                     maxlength="150"
                                     :class="{ 'is-invalid': $v.prestador.sep_razao_social_prestador.$error }"
                                     id="tps_razao_social_nome" type="text">
                              <div v-if="$v.prestador.sep_razao_social_prestador.$error" class="invalid-feedback">
                                Informe o Nome/Razão social
                              </div>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="Telefone" label-for="sep_telefone_prestador">
                              <the-mask class="form-control"
                                        :class="{ 'is-invalid': $v.prestador.sep_telefone_prestador.$error }"
                                        v-model="prestador.sep_telefone_prestador"
                                        :mask="['(##) ##### ####', '(##) #### ####']"/>
                              <div v-if="$v.prestador.sep_telefone_prestador.$error" class="invalid-feedback">
                                Informe o telefone com DDD
                              </div>
                            </b-form-group>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <b-form-group label="E-mail" label-for="sep_email_prestador">
                              <input v-model="prestador.sep_email_prestador"
                                     :class="{ 'is-invalid': $v.prestador.sep_email_prestador.$error }"
                                     class="form-control"
                                     maxlength="80"
                                     id="sep_email_prestador" type="email">
                              <div v-if="$v.prestador.sep_email_prestador.$error" class="invalid-feedback">
                                Informe um e-mail válido
                              </div>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="Inscrição municipal" label-for="sep_inscricao_prestador">
                              <input class="form-control"
                                     maxlength="15"
                                     v-bind:disabled="prestador.eco_inscricaomunicipal"
                                     v-model="prestador.sep_inscricao_prestador"
                                     id="sep_inscricao_prestador"
                                     type="text">
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="Inscrição estadual" label-for="sep_inscricao_estadual_prestador">
                              <input class="form-control"
                                     maxlength="15"
                                     v-model="prestador.sep_inscricao_estadual_prestador"
                                     id="sep_inscricao_estadual_prestador"
                                     type="text">
                            </b-form-group>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <b-form-checkbox
                                v-model="prestador.sep_optante_simples_nacional"
                                :value="true"
                                :unchecked-value="false"
                                class="custom-checkbox custom-checkbox-outline custom-checkbox-primary mb-3 font-size-15">
                              Prestador é optante pelo Simples Nacional (MEIs, MEs ou EPPs)
                            </b-form-checkbox>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <div class="row">
                              <h5 class="mb-3">Endereço do Prestador</h5>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-3">
                            <b-form-group
                                id="cep-group"
                                label="CEP"
                                label-for="cep-reply">
                              <input
                                  id="cep-reply"
                                  ref="sep_cep_prestador"
                                  v-model="prestador.sep_cep_prestador"
                                  v-on:focusout="locCEP(prestador.sep_cep_prestador)"
                                  autocomplete="no"
                                  v-mask="'##.###-###'"
                                  type="text"
                                  maxlength="20"
                                  class="form-control"
                                  placeholder=" "
                                  :class="{'is-invalid': errorCep || (submitted && $v.prestador.sep_cep_prestador.$error)}">
                              <div v-show="$v.prestador.sep_cep_prestador.$error" class="invalid-feedback">
                                Informe um CEP
                              </div>
                              <div v-show="errorCep" class="invalid-feedback">
                                CEP não encontrado
                              </div>
                            </b-form-group>
                          </div>
                          <div class="col-md-6">
                            <b-form-group
                                id="cidade-group"
                                label="Cidade - UF"
                                label-for="cidade">
                              <h5 v-if="prestador.sep_municipio_prestador" class="mb-3 mt-3">{{ prestador.mun_nome }} -
                                {{ prestador.mun_uf }}</h5>
                            </b-form-group>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-4">
                            <b-form-group
                                id="quadra-group"
                                label="Endereço/Quadra"
                                label-for="sep_endereco_prestador">
                              <input
                                  id="quadra"
                                  ref="sep_endereco_prestador"
                                  v-model="prestador.sep_endereco_prestador"
                                  type="text"
                                  maxlength="125"
                                  class="form-control"
                                  placeholder=" "
                                  :class="{'is-invalid': submitted && $v.prestador.sep_endereco_prestador.$error,}">
                              <div v-show="$v.prestador.sep_endereco_prestador.$error" class="invalid-feedback">
                                Informe seu endereço
                              </div>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group
                                id="lote-group"
                                label="Número/Lote"
                                label-for="sep_numero_endereco_prestador">
                              <input
                                  id="sep_numero_endereco_prestador"
                                  ref="sep_numero_endereco_prestador"
                                  v-model="prestador.sep_numero_endereco_prestador"
                                  type="text"
                                  maxlength="10"
                                  class="form-control"
                                  placeholder=" "
                                  :class="{'is-invalid': submitted && $v.prestador.sep_numero_endereco_prestador.$error,}">
                              <div v-show="$v.prestador.sep_numero_endereco_prestador.$error" class="invalid-feedback">
                                Seu Número
                              </div>
                            </b-form-group>
                          </div>
                          <div class="col-md-5">
                            <b-form-group
                                id="bairro-group"
                                label="Bairro"
                                label-for="sep_bairro_prestador">
                              <input
                                  id="sep_bairro_prestador"
                                  v-model="prestador.sep_bairro_prestador"
                                  type="text"
                                  maxlength="60"
                                  class="form-control"
                                  placeholder=" "
                                  :class="{'is-invalid': submitted && $v.prestador.sep_bairro_prestador.$error,}">
                              <div v-show="$v.prestador.sep_bairro_prestador.$error" class="invalid-feedback">
                                Informe o bairro
                              </div>
                            </b-form-group>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-4">
                            <b-form-group
                                id="complemento-group"
                                label="Complemento"
                                label-for="complemento">
                              <input
                                  id="complemento"
                                  v-model="prestador.sep_complemento_endereco_prestador"
                                  type="text"
                                  maxlength="60"
                                  class="form-control"
                                  placeholder=" ">
                            </b-form-group>
                          </div>
                        </div>
                      </b-form>
                    </div>
                  </div>
                </tab-content>
                <tab-content :before-change="validaTabValores" :lazy="true" title="Valores" icon="bx bx-envelope">
                  <div class="row">
                    <div class="col-12">
                      <b-form>
                        <div class="row">
                          <h5 class="mb-3">Informações sobre valores</h5>
                        </div>
                        <div class="row justify-content-start">
                          <div class="col-md-3">
                            <b-form-group label="Valor do serviço" label-for="sep_valor">
                              <money class="form-control" id="sep_valor"
                                     :class="{ 'is-invalid': submittedValores && $v.valores.sep_valor.$error}"
                                     v-model="valores.sep_valor"
                                     v-bind="money"></money>
                              <div v-if=" submittedValores && $v.valores.sep_valor.$error" class="invalid-feedback">
                                Valor do serviço
                              </div>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="Deduções" label-for="sep_deducoes">
                              <input v-show="servico.ser_codigo.ser_deducao && servico.ser_codigo.ser_deducao === 'N'"
                                     class="form-control"
                                     v-bind:disabled="true"
                                     value="R$ 0,00"/>
                              <money v-show="servico.ser_codigo.ser_deducao && servico.ser_codigo.ser_deducao === 'S'"
                                     class="form-control"
                                     id="sep_deducoes"
                                     v-model="valores.sep_deducoes"
                                     v-bind="money"></money>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="Alíquota ISS %" label-for="sep_aliquotaDemais">
                              <money class="form-control"
                                     id="sep_aliquotaDemais"
                                     :disabled="verificaAliquota.desabilitaAliquota"
                                     :class="{'is-invalid': $v.valores.sep_aliquota.$error}"
                                     v-model="valores.sep_aliquota"
                                     v-bind="money_porcent"></money>
                              <div v-if=" $v.valores.sep_aliquota.$error" class="invalid-feedback">
                                Aliquota entre 2,00 a 5,00
                              </div>
                            </b-form-group>
                          </div>
                        </div>
                        <div class="row justify-content-start">
                          <div class="col-md-4">
                            <b-form-group label="Desconto incondicionado" label-for="sep_desconto_incondicionado">
                              <money class="form-control" id="sep_desconto_incondicionado"
                                     v-model="valores.sep_desconto_incondicionado"
                                     v-bind="money"></money>
                            </b-form-group>
                          </div>
                          <div class="col-md-4">
                            <b-form-group label="Desconto condicionado" label-for="sep_desconto_condicionado">
                              <money class="form-control" id="sep_desconto_condicionado"
                                     v-model="valores.sep_desconto_condicionado"
                                     v-bind="money"></money>
                            </b-form-group>
                          </div>
                        </div>
                        <div class="row mb-1">
                          <div class="col-md-3">
                            <b-form-group label="ISS retido?">
                              <b-form-radio
                                  @change="alterRentencao(valores.sep_iss_retido)"
                                  v-bind:disabled="!verificaRenetencao.ativo"
                                  v-model="valores.sep_iss_retido"
                                  class="custom-radio custom-control-inline"
                                  value="S">Sim
                              </b-form-radio>
                              <b-form-radio
                                  @change="alterRentencao(valores.sep_iss_retido)"
                                  v-bind:disabled="!verificaRenetencao.ativo"
                                  v-model="valores.sep_iss_retido"
                                  class="custom-control-inline"
                                  value="N">Não
                              </b-form-radio>
                            </b-form-group>
                          </div>
                          <div class="col-md-4">
                            <b-form-group label="Responsável por retenção?">
                              <b-form-radio
                                  v-bind:disabled="true"
                                  v-model="valores.sep_responsavel_retencao"
                                  class="custom-radio custom-control-inline"
                                  value="1">Tomador
                              </b-form-radio>
                            </b-form-group>
                          </div>
                        </div>
                        <div class="row mb-2 justify-content-start">
                          <div class="col-md-3">
                            <b-form-group label="INSS" label-for="sep_inss">
                              <money class="form-control" id="sep_inss"
                                     v-model="valores.sep_inss"
                                     v-bind="money"></money>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="IR" label-for="sep_ir">
                              <money class="form-control" id="sep_ir"
                                     v-model="valores.sep_ir"
                                     v-bind="money"></money>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="PIS" label-for="sep_pis">
                              <money class="form-control" id="sep_pis"
                                     v-model="valores.sep_pis"
                                     v-bind="money"></money>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="CSLL" label-for="sep_csll">
                              <money class="form-control" id="sep_csll"
                                     v-model="valores.sep_csll"
                                     v-bind="money"></money>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="COFINS" label-for="sep_cofins">
                              <money class="form-control" id="sep_cofins"
                                     v-model="valores.sep_cofins"
                                     v-bind="money"></money>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="Outras" label-for="sep_outras_retencoes">
                              <money class="form-control" id="sep_outras_retencoes"
                                     v-model="valores.sep_outras_retencoes"
                                     v-bind="money"></money>
                            </b-form-group>
                          </div>
                        </div>
                        <div class="row">
                          <h5 class="mb-3">Informações sobre o cálculo</h5>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="table-responsive">
                              <table class="table table-sm m-0">
                                <thead>
                                <tr>
                                  <th>Descrição</th>
                                  <th>Valor</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                  <th scope="row">Valor do Serviço</th>
                                  <td>
                                    <span
                                        class="badge badge-success font-size-12">{{
                                        valores.sep_valor | formatNumeroBr
                                      }}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="row">Desconto Deduções</th>
                                  <td>
                                    <span class="badge badge-danger font-size-12">{{
                                        valores.sep_deducoes | formatNumeroBr
                                      }}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="row">Desconto incondicionado</th>
                                  <td>
                                    <span class="badge badge-danger font-size-12">{{
                                        valores.sep_desconto_incondicionado | formatNumeroBr
                                      }}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="row">Alíquota</th>
                                  <td>
                                    <span
                                        class="badge badge-success font-size-12">{{
                                        valores.sep_aliquota + '%'
                                      }}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="row">Valor ISS</th>
                                  <td>
                                    <span class="badge badge-success font-size-12">{{ sep_iss | formatNumeroBr }}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="row">Desconto condicionado</th>
                                  <td>
                                    <span
                                        class="badge badge-danger font-size-12">{{
                                        valores.sep_desconto_condicionado | formatNumeroBr
                                      }}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="row">Retenções federais</th>
                                  <td>
                                     <span
                                         class="badge badge-danger font-size-12">{{
                                         retencao_federal | formatNumeroBr
                                       }}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="row">Valor Líquido</th>
                                  <td>
                                    <span
                                        class="badge badge-success font-size-12">{{
                                        valor_liquido | formatNumeroBr
                                      }}</span>
                                  </td>
                                </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <h6 v-show="valorISSNegativo" class="text-danger">Valor do ISS não pode ser negativo</h6>
                        <h6 v-show="valorLiquidoNegativo" class="text-danger">Valor líquido deve ser maior que R$
                          0,00</h6>
                      </b-form>
                    </div>
                  </div>
                </tab-content>
                <tab-content title="Emissão" :lazy="true" icon="bx bx-check-double">
                  <Loader :loading="httpSend">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="row">
                          <h5 class="mb-3">Resumo do Ranfs</h5>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-3">
                        <label>CPF/CNPJ</label>
                        <p>{{ prestador.sep_cpf_cnpj_prestador }}</p>
                      </div>
                      <div class="col-md-5">
                        <label>Nome/Razão Social</label>
                        <p>{{ prestador.sep_razao_social_prestador }}</p>
                      </div>
                      <div class="col-md-4">
                        <label>E-mail</label>
                        <p>{{ prestador.sep_email_prestador }}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-3">
                        <label>Competência</label>
                        <p>{{ competencia.mes }}/{{ competencia.ano }}</p>
                      </div>
                      <div class="col-md-4">
                        <label>Município onde é devido o ISS</label>
                        <p>{{ servico.sep_municipio_incidencia.mun_nome }}-{{
                            servico.sep_municipio_incidencia.mun_uf
                          }}</p>
                      </div>
                      <div class="col-md-5">
                        <label>Município onde o serviço foi prestado</label>
                        <p>{{ servico.sep_municipio_prestacao.mun_nome }}-{{
                            servico.sep_municipio_prestacao.mun_uf
                          }}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <label>Atividade desenvolvida</label>
                        <p>{{ servico.ser_codigo.ser_codigo }}-{{ servico.ser_codigo.ser_descricao }}</p>
                      </div>
                    </div>
                    <div v-if="servico.cnae_codigo" class="row">
                      <div class="col-md-12">
                        <label>Cnae</label>
                        <p>{{ servico.cnae_codigo.cnae_codigo }}-{{ servico.cnae_codigo.cnae_nome }}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <label>Descrição dos serviço</label>
                        <textarea
                            v-model="servico.sep_discriminacao"
                            class="form-control"
                            v-bind:disabled="true"
                            :maxlength="2000"
                            rows="15"></textarea>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="table-responsive">
                          <table class="table table-sm m-0">
                            <thead>
                            <tr>
                              <th>Descrição</th>
                              <th>Valor</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                              <th scope="row">Valor do Serviço</th>
                              <td>
                                    <span
                                        class="badge badge-success font-size-12">{{
                                        valores.sep_valor | formatNumeroBr
                                      }}</span>
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Desconto incondicionado</th>
                              <td>
                                    <span class="badge badge-danger font-size-12">{{
                                        valores.sep_desconto_incondicionado | formatNumeroBr
                                      }}</span>
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Alíquota</th>
                              <td>
                                    <span
                                        class="badge badge-success font-size-12">{{
                                        valores.sep_aliquota + '%'
                                      }}</span>
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Valor ISS</th>
                              <td>
                                <span class="badge badge-success font-size-12">{{ sep_iss | formatNumeroBr }}</span>
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Desconto condicionado</th>
                              <td>
                                    <span
                                        class="badge badge-danger font-size-12">{{
                                        valores.sep_desconto_condicionado | formatNumeroBr
                                      }}</span>
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Retenções federais</th>
                              <td>
                                     <span
                                         class="badge badge-danger font-size-12">{{
                                         retencao_federal | formatNumeroBr
                                       }}</span>
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Valor Líquido</th>
                              <td>
                                   <span
                                       class="badge badge-success font-size-12">{{
                                       valor_liquido | formatNumeroBr
                                     }}</span>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </Loader>
                </tab-content>
                <template slot="footer" scope="props">
                  <div class=wizard-footer-left>
                    <wizard-button v-if="props.activeTabIndex > 0" @click.native="props.prevTab()"
                                   :style="props.fillButtonStyle"><i class="fas fa-arrow-left"></i> Anterior
                    </wizard-button>
                  </div>
                  <div class="wizard-footer-right">
                    <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right"
                                   :style="props.fillButtonStyle">Próximo <i class="fas fa-arrow-right"></i>
                    </wizard-button>
                    <button v-if="props.isLastStep" type="button"
                            @click="confirmacao()"
                            class="wizard-footer-right btn btn-label btn-success"><i
                        class="bx bx-check-double label-icon"></i>
                      Emitir Ranfs
                    </button>
                  </div>
                </template>
              </form-wizard>
            </div>
          </Loader>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Multiselect from 'vue-multiselect'
import {TheMask} from 'vue-the-mask'
import {VMoney, Money} from 'v-money'
import Loader from "@/components/widgets/loader";
import Aguarde from "@/components/widgets/aguarde";
import Layout from "../../layouts/main";
import appConfig from "@/dados/app.config.json";
import PageHeader from "@/components/page-header";
import {FormWizard, TabContent, WizardButton} from "vue-form-wizard";
import {required, email, minValue, maxValue} from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import {getCEP} from "@/api/externa/cep";
import {getPrestador} from "@/api/core/pessoa";
import {autocompleteCnae, autocompleteMunicipio, autocompleteServicos} from "@/api/geral/autocomplete";
import moment from "moment";
import {arredondamento, isMobile} from "@/helps/util";
import {notifyErro, notifySucesso} from "@/helps/notificacao";
import {solicitarRanfs} from "@/api/ranfs/ranfs";
import {impressao} from "@/helps/impressao";
import {setRelRanfs} from "@/api/relatorio/ranfs";
import NotaFiscal from "@/router/views/nota_fiscal/components/nota-fiscal.vue";

export default {
  page: {
    title: "Emitir Ranfs",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    NotaFiscal,
    Layout,
    Multiselect,
    TheMask,
    Money,
    Loader,
    Aguarde,
    PageHeader,
    FormWizard,
    TabContent,
    WizardButton,
  },
  directives: {money: VMoney},
  data() {
    return {
      title: "Registro Auxiliar de Nota Fiscal de Serviço (RANFS)",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'RANFS',
          href: '/contribuinte/solicitacao',
        },
        {
          text: 'Emitir',
          active: true,
        },
      ],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2
      },
      money_porcent: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '%',
        precision: 2
      },
      httpSend: false,
      showAguarde: false,
      prestador: {
        sep_cpf_cnpj_prestador: '',
        sep_razao_social_prestador: '',
        sep_inscricao_prestador: '',
        sep_inscricao_estadual_prestador: '',
        sep_endereco_prestador: '',
        sep_numero_endereco_prestador: '',
        sep_complemento_endereco_prestador: '',
        sep_bairro_prestador: '',
        sep_municipio_prestador: '',
        sep_cep_prestador: '',
        sep_email_prestador: '',
        sep_telefone_prestador: '',
        sep_optante_simples_nacional: false
      },
      servicos: [],
      cnaes: [],
      servico: {
        ran_numero: "",
        ran_nota_emissao: "",
        ran_not_nsu: "",
        sep_competencia: "",
        sep_exigibilidade_iss: "1",
        sep_municipio_incidencia: {
          mun_codigo: "",
          mun_nome: "",
          mun_uf: "",
        },
        sep_municipio_prestacao: {
          mun_codigo: "",
          mun_nome: "",
          mun_uf: "",
        },
        ser_codigo: {
          ser_codigo: null,
          ser_deducao: null,
          ser_descricao: null,
          sre_aliquota: null,
          sre_retencao: null,
          sre_substituicao: null,
        },
        cnae_codigo: {
          cnae_codigo: null,
          cnae_nome: null
        },
        sep_discriminacao: "",
      },
      valores: {
        sep_valor: 0.00,
        sep_iss: 0.00,
        sep_deducoes: 0.00,
        sep_aliquota: 0.00,
        sep_desconto_incondicionado: 0.00,
        sep_desconto_condicionado: 0.00,
        sep_iss_retido: 'N',
        sep_responsavel_retencao: '1',
        sep_inss: 0.00,
        sep_ir: 0.00,
        sep_pis: 0.00,
        sep_csll: 0.00,
        sep_cofins: 0.00,
        sep_outras_retencoes: 0.00
      },
      competencia: {
        mes: moment().format('M'),
        ano: moment().format('YYYY'),
      },
      verificaAliquota: {
        desabilitaAliquota: false
      },
      verificaTributacao: {
        disableTributacao: true,
        disableForaMunicipio: true,
        disableImune: true
      },
      verificaRenetencao: {
        ativo: false
      },
      aliquota: 0.00,
      municipios: [],
      tipoEndExiste: false,
      errorCep: false,
      valorLiquidoZerado: false,
      valorISSNegativo: false,
      valorLiquidoNegativo: false,
      submitted: false,
      submittedServicos: false,
      submittedValores: false,
      isLoading: false,
      desableIssRetido: false
    };
  },
  validations: {
    prestador: {
      sep_cpf_cnpj_prestador: {
        required,
      },
      sep_razao_social_prestador: {
        required,
      },
      sep_telefone_prestador: {
        required,
      },
      sep_email_prestador: {
        required,
        email
      },
      sep_endereco_prestador: {
        required,
      },
      sep_numero_endereco_prestador: {
        required,
      },
      sep_bairro_prestador: {
        required,
      },
      sep_cep_prestador: {
        required,
      },
    },
    competencia: {
      mes: {
        required
      },
      ano: {
        required
      }
    },
    servico: {
      ran_numero: {
        required
      },
      ran_nota_emissao: {
        required
      },
      ran_not_nsu: {
        required
      },
      sep_municipio_incidencia: {
        required
      },
      sep_municipio_prestacao: {
        required
      },
      ser_codigo: {
        ser_codigo: {
          required
        }
      },
      sep_discriminacao: {
        required
      }
    },
    valores: {
      sep_valor: {
        required,
        minValue: minValue(0.01)
      },
      sep_aliquota: {
        required,
        minValue: minValue(2.00),
        maxValue: maxValue(5.00)
      },
    },
  },
  created() {
    if (this.entidade) {
      this.municipioPadrao();
      this.servico.sep_municipio_prestacao.mun_codigo = this.entidade.mun_codigo;
      this.servico.sep_municipio_prestacao.mun_nome = this.entidade.mun_nome;
      this.servico.sep_municipio_prestacao.mun_uf = this.entidade.mun_uf;
    }
  },
  computed: {
    entidade: {
      get: function () {
        return this.$store.state.auth.currentEntidade;
      },
    },
    empresa: {
      get: function () {
        if (this.$store.state.auth.currenEmpresa) {
          return this.$store.state.auth.currenEmpresa;
        } else {
          return {eco_tributacao: null}
        }
      },
    },
    sep_competencia: {
      get: function () {
        if (this.competencia.mes && this.competencia.ano) {
          return this.competencia.mes + '/' + this.competencia.ano;
        }
        return '';
      },
    },
    sep_competencia_data: {
      get: function () {
        if (this.competencia.mes && this.competencia.ano) {
          return this.competencia.ano + '-' + this.competencia.mes + '-01';
        }
        return '';
      },
    },
    sep_iss: {
      get: function () {
        return (((this.valores.sep_valor - this.valores.sep_deducoes) - this.valores.sep_desconto_incondicionado) * this.valores.sep_aliquota) / 100;
      },
    },
    retencao_federal: {
      get: function () {
        return this.valores.sep_inss + this.valores.sep_ir + this.valores.sep_pis + this.valores.sep_csll + this.valores.sep_cofins + this.valores.sep_outras_retencoes;
      },
    },
    valor_liquido: {
      get: function () {
        const iss_retido = (this.valores.sep_iss_retido === 'S') ? this.valores.sep_iss : 0.00;
        return this.valores.sep_valor - (iss_retido + this.valores.sep_desconto_incondicionado + this.valores.sep_desconto_condicionado + this.retencao_federal)
      },
    },
  },
  watch: {
    sep_iss: {
      handler(val) {
        this.valores.sep_iss = val;
      },
    },
  },
  methods: {
    municipioPadrao() {
      this.servico.sep_municipio_incidencia.mun_codigo = this.entidade.mun_codigo;
      this.servico.sep_municipio_incidencia.mun_nome = this.entidade.mun_nome;
      this.servico.sep_municipio_incidencia.mun_uf = this.entidade.mun_uf;
    },
    locCEP(cep) {
      if (!cep) {
        return
      }
      this.httpSend = true;
      this.errorCep = false;
      getCEP(cep).then(result => {
        if (result.status === 200) {
          if (Object.prototype.hasOwnProperty.call(result.data, 'erro')) {
            this.$refs.sep_cep_prestador.focus();
            this.errorCep = true;
            this.prestador.mun_uf = '';
            this.prestador.mun_nome = '';
            this.prestador.sep_municipio_prestador = null;
            this.prestador.sep_bairro_prestador = '';
            this.prestador.sep_endereco_prestador = '';
          } else {
            this.errorCep = false;
            this.prestador.mun_uf = result.data.uf;
            this.prestador.mun_nome = result.data.localidade;
            this.prestador.sep_municipio_prestador = result.data.ibge;
            this.prestador.sep_bairro_prestador = result.data.bairro;
            this.prestador.sep_endereco_prestador = result.data.logradouro;
            if (this.prestador.sep_endereco_prestador) {
              this.$refs.sep_numero_endereco_prestador.focus();
            } else {
              this.$refs.sep_endereco_prestador.focus()
            }
          }
        }
      }).catch(error => {
        this.errorCep = true;
        this.prestador.mun_uf = '';
        this.prestador.mun_nome = '';
        this.prestador.sep_municipio_prestador = null;
        console.log(error)
      }).finally(() => {
        this.httpSend = false
      })
    },
    locTomador(sep_cpf_cnpj_prestador) {
      if (!sep_cpf_cnpj_prestador) {
        return
      }
      this.httpSend = true;
      getPrestador({cpf_cnpj: sep_cpf_cnpj_prestador}).then(result => {
        if (result.status) {
          this.prestador = result.dados;
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false
      })
    },
    pesquisarMunicipio(search) {
      if (search && search.length > 1) {
        this.isLoading = true;
        autocompleteMunicipio({query: search}).then(response => {
          if (response.status) {
            if (response.dados) {
              this.municipios = response.dados;
            }
          }
        }).catch(error => {
          console.log(error);
        }).finally(() => {
          this.isLoading = false;
        })
      }
    },
    labelServico({ser_codigo, ser_descricao}) {
      if (!ser_codigo) return "Digite o código ou descrição do Atividade para pesquisar";
      return `${ser_codigo} - ${ser_descricao}`
    },
    labelCnae({cnae_codigo, cnae_nome}) {
      if (!cnae_codigo) return "Digite o código ou descrição do CNAE para pesquisar";
      return `${cnae_codigo} - ${cnae_nome}`
    },
    labelMunicipio({mun_nome, mun_uf}) {
      return `${mun_nome} - ${mun_uf}`
    },
    pesquisarServicos(search) {
      if (search && search.length > 1) {
        this.isLoading = true;
        autocompleteServicos({query: search}).then(response => {
          if (response.status) {
            this.servicos = response.dados;
          }
        }).catch(error => {
          console.log(error);
        }).finally(() => {
          this.isLoading = false;
        })
      }
    },
    pesquisarCnae(search) {
      if (search && search.length > 1) {
        this.isLoading = true;
        autocompleteCnae({query: search}).then(response => {
          if (response.status) {
            this.cnaes = response.dados;
          }
        }).catch(error => {
          console.log(error);
        }).finally(() => {
          this.isLoading = false;
        })
      }
    },
    selctAtividade(selectedOption) {
      let retencao = selectedOption.sre_retencao === 'S';
      let aliquota = parseFloat(selectedOption.sre_aliquota);
      if (aliquota < 0.01) {
        this.verificaTributacao.disableForaMunicipio = !retencao;
        this.verificaTributacao.disableImune = false;
        this.verificaTributacao.disableTributacao = true;
        this.servico.sep_exigibilidade_iss = '5';
      } else {
        this.verificaTributacao.disableForaMunicipio = !retencao;
        this.verificaTributacao.disableImune = true;
        this.verificaTributacao.disableTributacao = false;
        this.servico.sep_exigibilidade_iss = '1';
      }
    },
    selctTributacao(selectedOption) {
      let tipoTributacao = parseInt(selectedOption);
      if (tipoTributacao !== 2) {
        this.municipioPadrao();
        this.municipios = [];
      }
    },
    alterRentencao(value) {
      if (value === 'S') {
        this.valores.sep_responsavel_retencao = '1';
      } else {
        this.valores.sep_responsavel_retencao = '0';
      }
    },
    validaTabPrestador: function () {
      this.$v.$touch();
      this.submitted = true;
      if (this.$v.prestador.$invalid) {
        return false;
      } else {
        if (!this.prestador.sep_municipio_prestador) {
          notifyErro("Erro no CEP", "Verifique se o CEP foi digitado corretamente. Não utilize o autocompletar do navegador")
          return false;
        }
        /*
        if (parseInt(this.prestador.sep_municipio_prestador) === parseInt(this.entidade.mun_codigo)) {
          notifyErro("Ranfs", "Cidade do prestador deve ser diferente de " + this.entidade.mun_nome + ' - ' + this.entidade.mun_uf)
          return false;
        }*/
        window.scrollTo(0, 0);
        return true;
      }
    },
    validaTabServico: function () {
      this.$v.$touch();
      this.submittedServicos = true;
      if (this.$v.competencia.$invalid || this.$v.servico.$invalid) {
        return false;
      } else {
        this.valores.sep_iss_retido = 'S';
        this.valores.sep_responsavel_retencao = '1';
        this.valores.sep_aliquota = parseFloat((this.servico.ser_codigo && this.servico.ser_codigo.sre_aliquota) ? this.servico.ser_codigo.sre_aliquota : '0.00');
        this.verificaAliquota.desabilitaAliquota = !this.prestador.sep_optante_simples_nacional;
        if (parseInt(this.servico.sep_municipio_incidencia.mun_codigo) !== parseInt(this.entidade.mun_codigo)) {
          this.verificaAliquota.desabilitaAliquota = false;
        }
        window.scrollTo(0, 0);
        return true;
      }
    },
    validaTabValores: function () {
      this.valorLiquidoNegativo = false;
      this.valorISSNegativo = false;
      this.$v.$touch();
      this.submittedValores = true;
      if (this.$v.valores.$invalid) {
        return false;
      }
      if (this.sep_iss < 0) {
        this.valorISSNegativo = true;
        return false
      }
      if (this.valor_liquido < 0.01) {
        this.valorLiquidoNegativo = true;
        return false
      }
      if (this.valores.sep_aliquota < 0.01) {
        return false
      }
      window.scrollTo(0, 0);
      return true;
    },
    confirmacao: function () {
      Swal.fire({
        title: "Deseja emitir a Ranfs?",
        text: "",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#100e0e",
        confirmButtonText: "Sim",
        cancelButtonText: "Não"
      }).then(result => {
        if (result.isConfirmed) {
          this.solicitaRanfs();
        }
      });
    },
    solicitaRanfs() {
      this.showAguarde = true;
      const dados = {
        eco_codigo: this.empresa.eco_codigo,
        prestador: this.prestador,
        competencia: this.competencia,
        servico: this.servico,
        valores: this.valores,
      }
      dados.valores.sep_iss = arredondamento(dados.valores.sep_iss);
      solicitarRanfs({dados}).then(response => {
        if (response.status) {
          notifySucesso("Ranfs", response.mensagem)
          this.visualiza_ranfs(response.dados);
        } else {
          notifyErro("Erro", response.mensagem)
        }
      }).catch(error => {
        notifyErro("Erro", error)
      }).finally(() => {
        this.showAguarde = false
      })
    },
    visualiza_ranfs(ranfs) {
      this.httpSend = true;
      if (isMobile()) {
        impressao(setRelRanfs(ranfs.ran_hash), 'P').catch(error => {
          console.log(error)
        }).finally(() => {
          this.httpSend = false;
        })
      } else {
        this.$router.push({name: 'contribuinte-ranfs-visualizar', params: {ran_hash: ranfs.ran_hash}})
      }
    },
    isLastStep() {
      if (this.$refs.tabNota) {
        return this.$refs.tabNota.isLastStep
      }
      return false
    },
  }
};
</script>
<style>
input[type="text"][disabled] {
  background-color: #f6f6f9;
}

select option:disabled {
  background-color: #f6f6f9;
}

.option__title {
  word-wrap: break-word;
  white-space: normal;
}

.is-invalid {
  border: 1px solid #f46a6a;
  border-radius: 0.25rem;
}
</style>

